import React, { useContext, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import AuthContext from '../context/AuthContext';


function LoginPage() {
  const { loginUser } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { username, password } = e.target;

    if (username.value.trim() && password.value.trim()) {
      loginUser(username.value, password.value);
    }
  };

  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh", overflow: "hidden" }}>
      <section className="flex-grow-1 d-flex align-items-center justify-content-center" >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10">
              <div className="card shadow-lg" style={{ borderRadius: "1rem" }}>
                <div className="row g-0">
                  <div className="col-md-5 d-none d-md-block">
                    <img
                      src="https://img.freepik.com/photos-premium/homme-affaires-travaillant-ordinateur-portable_13339-108094.jpg?w=740"
                      alt="Login"
                      className="img-fluid h-100"
                      style={{ borderRadius: "1rem 0 0 1rem", objectFit: "cover" }}
                    />
                  </div>

                  {/* Formulaire */}
                  <div className="col-md-7 d-flex align-items-center">
                    <div className="card-body p-4">
                      <div className="text-center mb-4">
                        <i className="fas fa-cubes fa-2x me-2" style={{ color: "#ff6219" }}></i>
                        <span className="h3 fw-bold">Bon retour 👋</span>
                      </div>
                      <h5 className="text-center fw-normal mb-3">Connectez-vous à votre compte</h5>

                      <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <label htmlFor="username" className="form-label fw-semibold text-secondary">Nom d'utilisateur</label>
                          <input 
                            type="text" 
                            id="username" 
                            name="username" 
                            className="form-control" 
                            required 
                            placeholder="Entrez votre nom d'utilisateur"
                          />
                        </div>

                        <div className="mb-3">
                          <label htmlFor="password" className="form-label fw-semibold text-secondary">Mot de passe</label>
                          <div className="input-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              name="password"
                              className="form-control"
                              required
                              placeholder="Entrez votre mot de passe"
                            />
                            <span
                              className="input-group-text"
                              style={{ cursor: "pointer" }}
                              onClick={() => setShowPassword(!showPassword)}
                              aria-label={showPassword ? "Masquer mot de passe" : "Afficher mot de passe"}
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>

                        <button className="btn w-100 fw-bold" type="submit" style={{ backgroundColor: "#1B019B", color: 'white' }}>
                          Se connecter
                        </button>
                      </form>

                      <div className="text-center mt-3">
                        <a 
                          className="small text-muted fw-semibold" 
                          href="mot-de-passe-oublier" 
                          style={{ color: '#1B019B', textDecoration: 'none' }}
                        >
                          Mot de passe oublié ?
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      
    </div>
  );
}

export default LoginPage;
